var _path, _path2, _text, _text2, _line, _polygon, _polygon2, _polygon3, _polygon4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeni(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "595.28px",
    height: "841.89px",
    viewBox: "0 0 595.28 841.89",
    enableBackground: "new 0 0 595.28 841.89",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BE1E2D",
    d: "M156.194,200.944l-8.311,0l0.018,198.694c0,0,83.888-2.029,146.517,38.384c0,0,31.401-34.622,146.993-39.165 l-0.02-197.939l-8.689,0.001l-0.358,189.628c0,0-115.59,8.454-137.686,40.186c0,0-65.92-45.08-137.693-39.029L156.194,200.944z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262262",
    d: "M140.767,191.307l-9.274,0l0.02,221.71c0,0,93.604-2.265,163.488,42.83c0,0,35.039-38.633,164.021-43.701 l-0.022-220.868l-9.695,0.002l-0.401,211.592c0,0-128.979,9.435-153.634,44.841c0,0-73.556-50.302-153.642-43.549L140.767,191.307z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 184.5654 483.5498)",
    fill: "#262262",
    fontFamily: "'ArialRoundedMTBold'",
    fontSize: 37
  }, "FERN  FIELD ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 208.3916 513.5215)",
    fill: "#BE1E2D",
    fontFamily: "'ComicSansMS'",
    fontSize: 23
  }, "CONSULTANTS ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#2B3990",
    stroke: "#2B3990",
    strokeMiterlimit: 10,
    x1: 181.984,
    y1: 493.25,
    x2: 424.809,
    y2: 490.245
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#262262",
    points: "438.493,450.465 441.802,452.131 430.216,476.153 427.245,474.725 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#BE1E2D",
    points: "425.61,475.252 425.866,490.567 438.908,481.585 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#262262",
    points: "447.356,445.246 431.719,476.786 435.119,478.47 451.04,445.966 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#BE1E2D",
    points: "454.705,440.916 435.678,479.767 439.343,481.322 457.83,442.545 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M425.516,484.727c0,0,4.94-1.98,4.745,2.936l-4.642,3.196l-0.271-5.268"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BE1E2D",
    d: "M392.296,252.169c3.901,2.642,4.282,7.995,5.638,11.978 c4.095,12.028,7.42,29.298,5.636,45.8c-2.182,20.173-9.38,37.717-19.023,51.438c-25.927,36.884-79.062,60.777-131.06,39.459 c-33.318-13.661-55.535-40.417-64.825-79.622c20.487,38.459,53.595,74.799,114.148,70.461c22.192-1.589,40.823-11.471,54.256-23.253 c13.9-12.19,23.299-29.253,28.184-49.323c-1.847-1.992-6.907,1.585-8.453,0c-3.27-20.453-8.578-38.868-11.979-59.188 C373.647,257.008,383.303,254.919,392.296,252.169z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262262",
    d: "M297.877,260.625c-6.084,6.418-18.664,5.642-26.071,11.978 c-2.579,2.206-5.733,6.497-9.161,11.275c-2.654,3.698-6.451,8.134-6.342,11.273c0.166,4.681,4.963,7.832,10.57,7.751 c9.65-0.14,15.25-11.437,21.138-14.797c6.661,0.739,12.407-1.422,17.616,0c9.181,9.902,22.535,22.41,33.82,34.526 c3.218,3.454,9.787,8.17,9.161,13.387c-0.267,2.216-3.275,5.333-4.229,5.637c-8.212,2.628-13.987-7.507-17.614-11.274 c-5.642-5.857-9.192-10.209-14.797-14.092c0.889,4.98,6.071,8.494,10.567,13.388c3.448,3.75,10.526,9.182,10.571,14.092 c0.038,4.397-2.997,7.583-7.751,7.751c-10.097,0.356-14.775-15.467-22.549-17.616c-1.504,6.619,14.964,12.186,15.501,19.025 c0.279,3.564-2.738,6.634-5.637,7.046c-8.269,1.177-17.282-15.779-23.957-17.616c3.048,8.227,12.086,10.462,16.206,17.616 c-0.898,3.541-6.251,4.861-9.863,3.523c0.502-6.506-0.915-16.091-9.865-12.683c-1.344-4.292-2.853-8.42-7.046-9.865 c-2.916-0.097-5.443,0.195-7.045,1.409c-2.38-6.691-10.726-11.614-18.321-7.046c0.301-7.738-9.163-11.576-14.797-7.045 c-8.195-3.55-14.702-8.786-22.548-12.684c7.857-16.1,15.208-32.706,22.548-49.323C257.432,280.353,276.194,254.881,297.877,260.625z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BE1E2D",
    d: "M362.701,264.147c3.275,17.394,7.645,33.694,10.57,51.437 c-12.004-0.025-17.358,6.599-23.957,11.979c-11.538-9.298-20.785-21.49-32.413-33.117c-3.534-3.532-8.017-8.968-11.273-9.864 c-5.452-1.501-14.511-0.609-18.32,0.705c-9.774,3.369-13.624,21.068-27.481,11.273c-1.207-4.027,3.219-6.545,5.637-9.864 c3.099-4.253,4.804-9.154,8.456-11.979c3.595-2.781,19.348-8.746,25.366-10.569c9.732-2.949,19.697,1.632,30.298,2.818 C340.806,268.221,351.219,264.752,362.701,264.147z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BE1E2D",
    d: "M240.099,328.972c12.643-4.639,14.452,13.422,2.818,13.387 C236.969,342.343,230.632,332.446,240.099,328.972z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BE1E2D",
    d: "M266.169,347.998c-1.201,1.659-7.145,5.4-11.275,4.932 c-3.556-0.404-8.052-4.086-7.75-8.457c0.303-4.411,8.465-8.918,9.864-9.16C265.535,333.843,271.627,340.454,266.169,347.998z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BE1E2D",
    d: "M266.169,347.998c2.384-2.753,6.701-5.506,8.455-5.638 c5.812-0.431,8.602,3.236,8.455,7.752c-0.127,3.896-7.027,10.774-9.16,11.273C265.771,363.291,259.475,355.723,266.169,347.998z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BE1E2D",
    d: "M292.945,354.339c2.548,11.191-11.237,15.601-15.502,7.75 C279.434,356.812,286.49,348.485,292.945,354.339z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262262",
    d: "M215.437,252.874c5.978,3.886,13.338,6.39,20.433,9.16 c-7.467,19.542-16.9,37.12-24.661,56.369c-8.122-3.623-16.412-7.077-24.662-10.569c-1.837-38.176,10.428-64.683,31.708-85.964 c16.671-16.671,39.546-29.111,65.529-31.003c50.723-3.691,80.059,19.145,101.464,47.209c-18.983-13.977-41.305-31.494-73.278-33.821 c-22.457-1.634-44.002,4.129-59.894,12.683C236.16,225.506,223.384,238.781,215.437,252.874z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeni);
export default __webpack_public_path__ + "static/media/feni.c4b6040c67b03ae02acf610904761c4e.svg";
export { ForwardRef as ReactComponent };